import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { GenerateCvService } from 'src/app/services/generate-cv/generate-cv.service';
import { PaymentService } from 'src/app/services/payment/payment.service';

@Component({
  selector: 'app-generate-linkedin-profile',
  templateUrl: './generate-linkedin-profile.component.html',
  styleUrls: ['./generate-linkedin-profile.component.css']
})
export class GenerateLinkedinProfileComponent {
  services = [
    {
      color: 'blue',
      img: '../../../assets/icon/headline.svg',
      title: 'Headline',
      description: [
        'File format and size',
        'Resume length',
        'Long bullet points with suggestions on how to shorten',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/summary.svg',
      title: 'Summary',
      description: [
        'Contact information',
        'Essential sections',
        'Personality showcase with tips on how to improve',
      ],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/contact.svg',
      title: 'Contacts',
      description: [
        'ATS parse rate',
        'Repetition of words and phrases',
        'Spelling and grammar',
        'Quantifying impact in experience section with examples',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/experience.png',
      title: 'Experience',
      description: ['Hard skills', 'Soft skills'],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/educatiion.svg',
      title: 'Education',
      description: [
        'Resume design',
        'Email address',
        'Usage of active voice',
        'Usage of buzzwords and cliches',
      ],
    },
  ];

  steps: MenuItem[] = [];
  activeIndex: any = 0;
  linkedin: any;
  loading: boolean = false;

  constructor(
    private translate: TranslateService,
    private cvService: GenerateCvService,
    private paymentService: PaymentService,
    private router: Router
  ) {
    this.getTranslate();
    this.translate.onLangChange.subscribe(() => {
      this.getTranslate();
    });
  }

  getTranslate() {
    this.translate.get(['Upload LinkedIn', 'Result']).subscribe((translations) => {
      this.steps = [
        { label: translations['Upload LinkedIn'] },
        { label: translations['Result'] },
      ];
    });
  }

  onLinkedinDrop(event: any) {
    event.preventDefault();
    this.linkedin = event.dataTransfer.files[0];
    if (this.linkedin) {
      this.nextStep();
    }
  }

  onLinkedinSelected(event: any) {
    this.linkedin = event.target.files[0];
    if (this.linkedin) {
      this.nextStep();
      if (this.activeIndex !== 1) return;

      this.loading = true;
      const data = new FormData();
      data.append('cvFile', this.linkedin);

      this.cvService.enhanceLinkedinCv(data).subscribe((res: any) => {
        this.loading = false;
        this.downloadFile(res[0], 'enhanced_profile.docx');
      });
    }
  }

  downloadFile(response: any, filename: string) {
    const binaryData = this.base64ToArrayBuffer(response);
    const blob = new Blob([binaryData], { type: 'application/octet-stream' });

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);

      link.href = url;
      link.download = filename;
      link.click();

      window.URL.revokeObjectURL(url);
    }
  }

  private base64ToArrayBuffer(base64: string): ArrayBuffer {
    let binaryString = '';
    if (typeof window !== 'undefined') {
      binaryString = window.atob(base64);
    }

    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  nextStep() {
    if (this.activeIndex === 0) {
      this.paymentService.checkIsProductPurchased('optimize-linkedin').then((purchased) => {
        if (purchased) {
          this.activeIndex = 1;
        } else {
          localStorage.setItem('redirectProductKey', 'optimize-linkedin');
          this.router.navigate(['/payment'], { state: { productKey: 'optimize-linkedin' }, queryParams: { productKey: 'optimize-linkedin' } });
        }
      })
    }
  }
}
